export default "__VITE_ASSET__DKI_ulpE__"